module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/higher-ed-mobile-49bc39ac0305f245bfee5138175eaed8.jpg";